// extracted by mini-css-extract-plugin
export default {"border":"GoldBorder_border__deJp+","secondBorder":"GoldBorder_secondBorder__nwLyn","container":"GoldBorder_container__o83uU","content":"GoldBorder_content__FJApQ"};